import React from "react";
import "./CTASection.css";

const CTASection: React.FC = () => {
  return (
    <>
      {/* 🔥 CTA */}
      <section className="cta">

        <h2>
          Ready to Place Your <br />
          Order Today?
        </h2>

        <p>
          ROHIT REGAL VENTURE offers high-quality eco-friendly bags at the best prices.
          Bulk orders, custom printing, and fast delivery.
        </p>

        <div className="cta-buttons">
          <a href="tel:8826246163" className="btn-green">
            Call Now
          </a>

          <a href="/contact" className="btn-light">
            Contact Us
          </a>
        </div>

      </section>

      {/* 🔥 FOOTER */}
      <footer className="footer">

        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/about">About Us</a>
          <a href="/services">Services</a>
          <a href="/contact">Contact</a>
        </div>

        <hr />

        <h3 className="brand">Rohit Regal Venture</h3>

        <p className="copyright">
          © 2026 Rohit Regal Venture. All rights reserved.
        </p>

      </footer>
    </>
  );
};

export default CTASection;